import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './app/App';
import reportWebVitals from './reportWebVitals';
// import {BrowserRouter} from 'react-router-dom';
import {ConnectedRouter} from 'connected-react-router'
// import Navigation from './container/Navigation'
import { Provider } from 'react-redux'
import store , {history} from './redux/store'
import FooterContainer from './container/FooterContainer';

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <ConnectedRouter history={history}>  
        <App />
      </ConnectedRouter>
      <FooterContainer />
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
